import React, { useRef } from 'react';

import PropTypes from 'prop-types';

import { useDrag, useDrop } from 'react-dnd';
import { Button } from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGripDotsVertical, faTimes } from '@fortawesome/pro-solid-svg-icons';

function Row({ contact, index, type, onRemoveContact, onReorder, onReorderSave }) {
  const ref = useRef(null);
  const dragRef = useRef(null);

  const [{ isDragging }, drag, preview] = useDrag({
    collect: monitor => ({ isDragging: monitor.isDragging() }),
    item: { ...contact, sortOrder: index },
    type,
    end() {
      onReorderSave();
    }
  });

  const [, drop] = useDrop({
    accept: type,
    hover(dragItem, monitor) {
      if (!monitor.canDrop()) return;
      if (dragItem.id === contact.id) return;

      onReorder(dragItem.id, index);
    }
  });

  preview(drop(ref));
  drag(dragRef);
  const opacity = isDragging ? 0 : 1;

  return (
    <div
      className="d-flex align-items-center justify-content-between py-2"
      key={contact.id}
      ref={ref}
      style={{ opacity }}
    >
      <div className="d-flex align-items-center flex-grow-1">
        <div className="px-3" ref={dragRef} style={{ cursor: 'grab' }}>
          <FontAwesomeIcon className="text-muted" icon={faGripDotsVertical}/>
        </div>
        <div>
          <p className="fw-semibold mb-1">{contact.name}</p>
          <div className="text-muted small">{contact.email}</div>
        </div>
      </div>
      <div>
        <Button
          aria-label="Remove contact"
          className="ps-2 text-destructive"
          size="sm"
          variant="link"
          onClick={() => onRemoveContact(contact)}
        >
          <FontAwesomeIcon className="text-destructive" icon={faTimes} />
        </Button>
      </div>
    </div>
  );
}

Row.propTypes = {
  contact: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    email: PropTypes.string
  }).isRequired,
  index: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,
  onRemoveContact: PropTypes.func.isRequired,
  onReorder: PropTypes.func.isRequired,
  onReorderSave: PropTypes.func.isRequired
};

export default Row;
